import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface ResultRowProps {
  label: string
  value: ReactNode
  emphasis?: boolean
}

const ResultRow = ({ label, value, emphasis }: ResultRowProps) => (
  <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ py: 0.75 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={emphasis ? 700 : 500} color="text.primary">
      {value}
    </Typography>
  </Stack>
)

export default ResultRow
